<template>
  <v-dialog
    width="600"
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card flat>
      <v-card-title class="title pb-0 font-weight-bold">
        Multi-Form Upload Confirmation
        <v-spacer />

        <v-btn
          small
          fab
          flat
          class="white error--text text-capitalize ma-0"
          @click="
            $emit('update:opened', false);
            $emit('update:documents', []);
          "
        >
          <v-icon size="20"> clear </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-xs-left">
          Do the documents you intend to upload require automatic splitting
          (contains more than one document)?
        </div>

        <v-layout column class="my-2">
          <v-layout align-center class="py-2">
            <span class="body-2">Document name</span>
            <v-spacer />
            <span class="body-2">Requires splitting?</span>
          </v-layout>

          <v-layout
            align-center
            :key="i"
            v-for="(document, i) in documents"
            class="py-2 row"
            style="border-top: 1px solid rgba(0, 0, 0, 0.12)"
          >
            <v-icon color="grey" class="mr-1 material-icons-outlined">
              insert_drive_file
            </v-icon>

            <span>
              {{ document.name }}
            </span>

            <v-spacer />

            <div class="checkbox-container">
              <v-tooltip
                v-if="!document.name.toLowerCase().endsWith('.pdf')"
                bottom
              >
                <v-icon class="grey--text" slot="activator">
                  block
                </v-icon>
                <span>This is not a PDF file thus it cannot be split.</span>
              </v-tooltip>

              <v-checkbox
                v-else
                hide-details
                class="mt-0"
                v-model="document.requiresSplitting"
              />
            </div>
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer class="hidden-xs-only" />
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          class="default-input primary text-capitalize"
          @click="$emit('proceed')"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },

    documents: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="postcss" scoped>
.checkbox-container {
  display: flex;
  justify-content: start;
  width: 50px;
  max-width: 50px;
}
.row {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
